import { Helmet } from 'react-helmet-async';
import { Box, Container } from '@mui/material';
import useSettings from '../../../hooks/useSettings';
import DetailPageHeader from '../../DetailPageHeader/DetailPageHeader';

const DetailPageLayout = ({
  title = '',
  headerText = '',
  breadcrumbsLinks = [],
  BodyComponent,
  ActionCommandComponent,
}) => {
  const { settings } = useSettings();

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Box
        sx={{
          //  backgroundColor: 'background.default',
          minHeight: '100%',
          pt: 4,
          pb: 8,
        }}
      >
        <Container maxWidth={settings.compact ? 'xl' : false}>
          <DetailPageHeader
            title={headerText}
            breadcrumbsLinks={breadcrumbsLinks}
            actionButtons={ActionCommandComponent}
          />

          {BodyComponent && <Box mt={3}>{BodyComponent}</Box>}

          {/* {ActionCommandComponent && (
            <Stack alignItems="flex-end" sx={{ mt: 2 }}>
              {ActionCommandComponent}
            </Stack>
          )} */}
        </Container>
      </Box>
    </>
  );
};

export default DetailPageLayout;
